export enum ToothLibrary {
    IVIT = 1,
    IVVO = 2,
    IVBL = 3,
    DSDP = 4,
    IVPH = 5,
    DSDG = 6,
    DSHG = 7,
    Other = 8,
}
